export const ComicData = {
    philosophy: {
        basePath: '../../assets/imgs/philosophy/',
        maxPics: 2,
        title: 'If I Only Knew Philosophy',
    }
};
